<template>
  <div :class="$style.wrapper">
    <BackToHub />
    <Header />
    <transition name="fade">
      <HelloPopup v-if="stage === 0" @click="() => { stage++ }">
        <h1>Привет!</h1>
        <p>
          Сейчас очень популярно общение в социальных сетях. Наверное, ты тоже временами сидишь в чатике с друзьями. Можно узнать много нового, если внимательно почитать, как люди общаются друг с другом: как отвечают, какие слова используют. «Зачем это может пригодиться?» - спросишь ты. А вот, например, пришли к тебе в гости друзья на День рождения, и их нужно рассадить так, чтобы всем было максимально весело и комфортно. Интересно? :) Попробуй проанализировать чат и определить, что объединяет ребят.
        </p>
      </HelloPopup>
    </transition>

    <div :class="$style.inner" v-if="!isMobile">
      <div :class="$style.left">
        <Chat v-if="stage === 1" />
        <template v-if="stage === 2">
          <DraggableContainer
            v-for="(group, index) in groupedUsers"
            :users="group"
            :key="index"
            :title="groupsTitle[index]"
            :icon="groupsIcons[index]"
          />
        </template>
        <DragTable v-if="stage > 2" :users="users" />
      </div>
      <div :class="$style.right">
        <DraggableUsers :users="users" v-if="stage === 1" />
        <StackedTable v-if="stage === 2" :heading="tableHeadings" />
        <StackedTable
          v-if="stage > 2"
          :heading="tableHeadings"
          :initial="stackedTableData"
          :disabled="true"
        />
      </div>
    </div>
    <div v-if="isMobile" :class="$style.inner2">

      <template v-if="stage === 1">
        <Chat :style="getDisplayClass(0)" />
        <DraggableUsers :users="users" :style="getDisplayClass(1)" ref="draggableUsers" />
      </template>

      <template v-if="stage === 2">
        <DraggableContainer
          v-for="(group, index) in groupedUsers"
          :style="getDisplayClass(0)"
          :users="group"
          :key="index"
          :title="groupsTitle[index]"
          :icon="groupsIcons[index]"
        />
        <StackedTable :style="getDisplayClass(1)" :heading="tableHeadings" ref="stackedTable" />
      </template>

      <template v-if="stage >= 3">
        <StackedTable
          :heading="tableHeadings"
          :initial="stackedTableData"
          :disabled="true"
          :style="getDisplayClass(0)"
        />
        <DragTable :style="getDisplayClass(1)" :users="users" />
      </template>

      <div :class="$style.buttonWrapper">
        <Button @click="() => { subStage = 0 }" v-if="subStage === 1">Назад</Button>
        <Button @click="nextMobileStage" v-if="stage < 3 || (stage === 3 && subStage === 0)">Далее</Button>
      </div>

    </div>
    <Transition name="fade">
      <Popup
        v-if="popupOpened"
        :opened="true"
        :topClass="$style.top"
      >
        <template v-slot:top>
          <div :class="$style.imageTop"></div>
        </template>
        <div :class="$style.thirdText">
          <p>Ты устраиваешь вечеринку для данной группы подростков. В твоём распоряжении 2 стола, каждый на 4-х человек. Сидя за столом, человек общается с соседями справа и слева. Чем приятнее собеседник, тем больше счастья. Рассади подростков так, чтобы их суммарное счастье было максимальным.</p>
        </div>
        <template v-slot:footer>
          <Button @click="() => { popupOpened = false }">Ок, понял</Button>
        </template>
      </Popup>
    </Transition>
    <Transition name="fade">
      <SuccessPopup
        v-if="stage === 4"
        :score="result"
        :max="PARTY.maxPoints"
        :achievement="PARTY.achievement"
        @click="() => { stage = 5 }"
      />
      <VideoPopup
        v-if="stage === 5"
        video="https://player.vimeo.com/video/370902951"
        @click="() => { $userStory.next({ result }) }"
      />
    </Transition>
    <Transition name="fade-right-bottom">
      <HintChar v-if="charVisible">{{charText}}</HintChar>
    </Transition>
  </div>
</template>
<script>
import Header from './components/Header/Header.vue'
import Chat from './components/Chat/Chat.vue'
import DraggableUsers from './components/DraggableUsers/DraggableUsers.vue'
import DraggableContainer from './components/DraggableUsers/components/DraggableContainer/DrabbagleContainer.vue'
import StackedTable from './components/StackedTable/StackedTable.vue'
import DragTable from './components/DragTable/DragTable.vue'
import HintChar from './components/HintChar/HintChar.vue'

import Popup from '@/components/@ui/Popup/Popup.vue'
import Button from '@/components/@ui/Button/Button.vue'
import SuccessPopup from '@/components/SuccessPopup/SuccessPopup.vue'
import HelloPopup from '@/components/HelloPopup/HelloPopup.vue'
import VideoPopup from '@/components/VideoPopup/VideoPopup.vue'
import BackToHub from '@/components/BackToHub/BackToHub.vue'

import { PARTY } from '@/services/UserStory'

import users from './users'

import Bus from './Bus'

import routerCheck from '@/mixins/routerCheck'

export default {
  name: 'Lesson4',
  components: {
    Header, Chat, HelloPopup, DraggableUsers, DraggableContainer, StackedTable, DragTable, SuccessPopup, HintChar, Button, Popup, VideoPopup, BackToHub,
  },
  mixins: [routerCheck],
  data: () => ({
    stage: 0,
    popupOpened: false,
    subStage: 0,
    users,
    groupedUsers: [],
    groupsTitle: [
      'Соседи',
      'Футбол',
      'Музыка',
      'Литература',
    ],
    groupsIcons: [
      require('./components/DraggableUsers/assets/sosedi.svg'),
      require('./components/DraggableUsers/assets/football.svg'),
      require('./components/DraggableUsers/assets/music.svg'),
      require('./components/DraggableUsers/assets/litra.svg'),
    ],
    tableHeadings: [
      'Скобец',
      'Запятыня',
      'Саша',
      'Ксюша',
      'Тёма',
      'Соня',
      'Аня',
      'Арсен',
    ],
    charVisible: false,
    timeoutID: null,
    stackedTableData: null,
    PARTY,
    // stackedTableData: [
    //   [false, true, true, false, false, false, false, false],
    //   [true, false, true, false, false, false, false, false],
    //   [true, true, false, true, false, false, false, false],
    //   [false, false, true, false, false, false, false, false],
    //   [false, false, false, false, false, true, true, false],
    //   [false, false, false, false, true, false, true, false],
    //   [false, false, false, false, true, true, false, true],
    //   [false, false, false, false, false, false, true, false],
    // ],
  }),
  computed: {
    charText() {
      const { stage } = this
      switch (stage) {
        case 1: return 'Прочитай чат и перемести карточки ребят, которых что-то объединяет, в соответствующие категории.'
        case 2: return 'Поставь галочки в таблице, чтобы отметить ребят, которых что-то объединяет.'
        default: return ''
      }
    },
    isMobile() {
      return this.$store.state.utils.isMobile
    },
  },
  methods: {
    openChar() {
      if (this.timeoutID) {
        clearTimeout(this.timeoutID)
        this.charVisible = false
        setTimeout(() => { this.toggleCharVisible() }, 500)
      } else {
        this.toggleCharVisible()
      }
    },
    toggleCharVisible() {
      this.charVisible = true
      this.timeoutID = setTimeout(() => {
        this.charVisible = false
      }, 5000)
    },
    nextMobileStage() {
      const { subStage } = this
      if (subStage === 0) {
        this.subStage = 1
      } else if (this.runSideEffectsBeforeNewStage()) {
        this.subStage = 0
        this.stage += 1
      }
    },
    runSideEffectsBeforeNewStage() {
      const { stage, $refs: { draggableUsers, stackedTable } } = this
      if (stage === 1) {
        draggableUsers.check()
        return false
      }
      if (stage === 2) {
        stackedTable.emit()
        return false
      }
      return true
    },
    getDisplayClass(needSubstage) {
      return {
        display: needSubstage === this.subStage ? '' : 'none',
      }
    },
  },
  watch: {
    stage(stage) {
      if (stage < 3) {
        this.openChar()
      }
      if (stage === 1) {
        this.$userStory.start()
      }
      if (stage === 3) {
        this.popupOpened = true
      }
    },
  },
  created() {
    Bus.$on('setUsers', (e) => {
      this.groupedUsers = e.map(group => group.map(id => users.find(i => i.id === id)))
    })
    Bus.$on('usersGroupReady', () => {
      this.subStage = 1
      this.stage += 1
    })
    Bus.$on('stackedTableReady', (data) => {
      this.stackedTableData = data
      this.subStage = 1
      this.stage += 1
    })
    Bus.$on('dragTableReady', (result) => {
      this.result = result
      this.subStage = 1
      this.stage += 1
    })
  },
}
</script>
<style lang="scss" module>
@import './Lesson4.scss';
</style>
